import { useLocation } from 'react-router-dom';
import { Box, Button, List, ListItem } from '@mui/material';
import './ErrorPage.scss';
import constants from '../../constants';

const ErrorPage = ({ from }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const missingPageIcon = require('../../img/missing-page.png');
    
    const textContent = {
        agency: {
            title: 'Partner verification error',
            message: 'Access to AMsuite+ cannot be granted with the Agency ID you\'ve provided. Please contact your system administrator.',
            buttonText: 'Continue to amig.com',
            infoText: `Agency id: ${queryParams.get('agencyID')}`
        },
        user: {
            title: 'Hmm.. Something is not right!',
            message: `Something in the request either doesn't match our records, cannot be found, or is otherwise already set up. Please contact your system administrator and provide the following details:`,
            buttonText: 'Continue to amig.com',
            infoText: ''
        }
    };

    const handleButtonClick = () => {
        window.location.href = 'https://agents.amig.com';
    }

    const { title, message, buttonText, infoText } = from === constants.agency ? textContent.agency : textContent.user;

    return (
        <Box className='errorPage-container'>
            <Box style={{ textAlign: 'center' }}>
                <img className='missing-page-icon' src={missingPageIcon} alt="Error" />
                <Box className='error-page-title'>{title}</Box>
                <Box className='error-page-text'>{message}</Box>
                <Box className='error-page-text'>{infoText}</Box>
                {from === 'user' && (
                    <Box className='error-page-text details'>
                        <List className='details-list'>
                            {queryParams.get('id') && <ListItem>username: {queryParams.get('id')}</ListItem>}
                            {queryParams.get('agencyID') && <ListItem>agencyID: {queryParams.get('agencyID')}</ListItem>}
                        </List>
                    </Box>
                )}
                <Box className='buttonsBox'>
                    <Box className='continueButton'>
                        <Button className='continue-button' onClick={handleButtonClick}>
                            {buttonText}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ErrorPage;
